// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".chakra-ui-light::-webkit-scrollbar {\n    display: none;\n}", "",{"version":3,"sources":["webpack://./src/Path/Listings/HeidiListings.css"],"names":[],"mappings":"AAAA;IACI,aAAa;AACjB","sourcesContent":[".chakra-ui-light::-webkit-scrollbar {\n    display: none;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
